import { toIdValue } from 'apollo-utilities'
import { ApolloClient } from 'apollo-client'
import { InMemoryCache } from 'apollo-cache-inmemory'
import { SchemaLink } from 'apollo-link-schema'
import { getApolloProviderWrapper } from '../components/apollo'
import { schema, createContext } from '../graphql'
import { LibraryUsageItemQueryArgs } from '../graphql/schema/queries/library-usage-item'
import { RouteQueryArgs } from '../graphql/schema/queries/route'

export const cache = new InMemoryCache({
  cacheRedirects: {
    Query: {
      application: (_, args) =>
        toIdValue(
          cache.config.dataIdFromObject({
            __typename: 'Application',
            id: args.applicationID
          })
        ),
      server: (_, args) =>
        toIdValue(
          cache.config.dataIdFromObject({
            __typename: 'Server',
            id: args.serverID
          })
        ),
      vulnerability: (_, args) =>
        toIdValue(
          cache.config.dataIdFromObject({
            __typename: 'Vulnerability',
            id: args.vulnerabilityID
          })
        ),
      vulnerabilityOrSinkGroup: (_, args) =>
        toIdValue(
          cache.config.dataIdFromObject({
            __typename: 'VulnerabilityOrSinkGroup',
            id: args.vulnerabilityOrSinkGroupId
          })
        ),
      library: (_, args) =>
        toIdValue(
          cache.config.dataIdFromObject({
            __typename: 'Library',
            id: `${args.hash}|${args.language}`
          })
        ),
      libraryUsageItem: (_, args: LibraryUsageItemQueryArgs) =>
        toIdValue(
          cache.config.dataIdFromObject({
            __typename: 'LibraryClassUsageItem',
            id: `${args.libraryHash}|${args.applicationID}|${args.name}`
          })
        ),
      route: (_, args: RouteQueryArgs) =>
        toIdValue(
          cache.config.dataIdFromObject({
            __typename: 'Route',
            id: args.id
          })
        ),
      attackEvent: (_, args) =>
        toIdValue(
          cache.config.dataIdFromObject({
            __typename: 'AttackEvent',
            id: args.attackEventID
          })
        )
    }
  }
})

const client = new ApolloClient({
  link: new SchemaLink({
    schema,
    context: createContext()
  }),
  cache,
  defaultOptions: {
    watchQuery: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'ignore'
    },
    query: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'all'
    },
    mutate: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'all'
    }
  }
})

export function wrapWithApolloProvider(rootScope) {
  return getApolloProviderWrapper(client, rootScope)
}
